export enum BoardSelectionStatusEnum {
  SELECT = 'select',
  DESELECT = 'deselect',
}
